import axios from "axios";
import { API_BASE_PATH } from "../environment";
import { toast } from "react-toastify";

// ✅ Base URL
const BASE_URL = `${API_BASE_PATH}`;


export interface Subscription {
  amount: number;
  subscription_id: string;
  plan_id: string;
  client_id: string;
  client_name: string;
  payment_id: string;
  plan_name: string | null;
  subscription_start_date: string;
  subscription_end_date: string;
  status: string;
  created_at: string;
}



export const getSubscriptions = async (): Promise<Subscription[]> => {
  try {
    const response = await axios.get<Subscription[]>(`${API_BASE_PATH}/subscriptions/`, {
      headers: {
        Accept: 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching subscriptions:', error);
    throw error;
  }
};

export const deleteSubscription = async (subscriptionId: string): Promise<void> => {
  try {
    const response = await axios.delete(`${API_BASE_PATH}/subscriptions/${subscriptionId}`, {
      headers: {
        Accept: 'application/json',
      },
    });
  } catch (error: any) {
    console.error('Failed to delete subscription:', error?.response?.data || error.message);
    throw error;
  }
};
